import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { getSubscriptionPrice } from '../../services/utils';
import Link from '../../ui-elements/Link/Link';
export const pricingPageData = {
    pricingPlansTable: [{
        label: "Verð á mánuði",
        forFreeUser: "0 kr.",
        forSubscriber: getSubscriptionPrice(true)
    }, {
        label: "Fjöldi aðganga",
        forFreeUser: "1",
        forSubscriber: "4"
    }, {
        label: "Skannaðir ársreikningar",
        forFreeUser: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />,
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Innslegnir ársreikningar",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Raunverulegir eigendur",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Fyrirtækjavakt",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Fréttavakt",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Samanburðar skýrslur",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }, {
        label: "Verðmat fyrirtækja",
        forFreeUser: "",
        forSubscriber: <FontAwesomeIcon icon={faCheck} className="icon-fa-check" />
    }],

    pepAndDdPrices: [
        {
            name: "KYC aðgangur (mánaðargjald)",
            subPrice: 1990,
            freePrice: null
        }, {
            name: "Áreiðanleikakönnun á lögaðilum",
            subPrice: 1490,
            freePrice: null
        }, {
            name: "Áreiðanleikakönnun á einstaklingum",
            subPrice: 790,
            freePrice: null
        },

        {
            name: <Link url="/Areidanleikakannanir" >Stjórnmálaleg tengsl (PEP) - stök uppfletting</Link>,
            subPrice: 195,
            freePrice: null
        }, {
            name: <Link url="/Areidanleikakannanir" >Alþjóðlegir válistar einstaklingar - stök uppfletting</Link>,
            subPrice: 195,
            freePrice: null
        }, {
            name: <Link url="/Areidanleikakannanir" >Alþjóðlegir válistar lögaðilar - stök uppfletting</Link>,
            subPrice: 195,
            freePrice: null
        },

        {
            name: "Vöktun einstaklings á móti alþjóðlegum válistum (ársfjórðungsgjald)",
            subPrice: 195,
            freePrice: null
        },
        {
            name: "Vöktun einstaklings á móti PEP (mánaðargjald)",
            subPrice: 24,
            freePrice: null
        },
        {
            name: "Vöktun á gildandi skráningu og eigendum (mánaðargjald)",
            subPrice: 24,
            freePrice: null
        },
    ]
}